import { Component } from '@angular/core';
import { DistributionDataService } from '../../../services/distributionData.service';
import { PoolingPortalService } from '../../../services/pooling-portal.service';
import { NavigationService } from '../../../services/navigation.service';
import { Subscription } from 'rxjs'; 
@Component({
  selector: 'app-dashboard',
  templateUrl: './dashboard.component.html',
  styleUrls: ['./dashboard.component.scss']
})
export class DashboardComponent  {

  //public latestUpdate:any;
  //isSkelton = false;
  fleet: any;
  subscription: Subscription;

  constructor(private _distributionDataService: DistributionDataService, private navService: NavigationService, private _poolingPortalService: PoolingPortalService,) { 
     
    //this.isSkelton = true;
      this.subscription = this._poolingPortalService.fleet$.subscribe(
      fleet => {
        this.fleet = fleet;
        //this.getDistributionLatestData();
      }
    )
  }
  
  /* getDistributionLatestData() {
    let formData = {"fleet": this.fleet};
    this._distributionDataService.getDistributionLatestData(formData)
      .subscribe({
        next: (res:any) => {
          if(res.data.getLatestMonthAndYear.success){
            this.isSkelton = false;
            if(res.data.getLatestMonthAndYear.data.lastUpdatedAt){
              this.latestUpdate= new Date(res.data.getLatestMonthAndYear.data.lastUpdatedAt);
            }
            else{
              this.latestUpdate= new Date();
            }
          }
        },
        error: (error) => {
          this.isSkelton = false;
         
        }
      });
  } */

  ngOnDestroy() {
    this.subscription.unsubscribe();
  }

}
